<template>
<div class="bimg">
<div class="login-bg">
    <div class="register-box">
    <div class="login-logo">
        <img src="../styles/images/login-logo2.png" tppabs="http://www.gxlyzjz.cn/r/cms/resource/images/login-logo2.png" alt=""
             style="border-top-left-radius: 5px;border-top-right-radius: 5px;">
    </div>
    <div class="register-nav"><span>注册</span>
        <div class="register-login">已有账号，<router-link to="/login" class="tc">马上登录</router-link></div>
    </div>
    <form id="jvForm" action="#" method="post" novalidate="novalidate">
        <div style="text-align:center; margin-top: 50px">
            <label><input type="radio" name="usertype" value="1"  checked="checked" id="r2">个人用户&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <label class="ml30"><input type="radio" name="usertype" value="2" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业用户</label>
        </div>
        <div class="register-list">
            <ul>
                <li><span>账号</span><input type="text" id="username" v-model="form.userName"
                                           name="username" placeholder="5~20字符，英文字母/数字" class="register-input">
                </li>
                <li><span>电子邮箱</span><input type="text" id="email" maxlength="30" v-model="form.userEmail"
                                            name="email" placeholder="用于找回密码" class="register-input">
                    <label  class="error" style="display: none;" id="emailerror"></label>
                </li>
                <li><span>设置密码</span><input id="password" type="password" name="loginPassword" v-model="form.userPassword"
                                            vld="{required:true,rangelength:[3,20]}" class="register-input"></li>
                <li><span>确认密码</span><input type="password" equalto="#password" vld="{required:true,rangelength:[3,20]}"
                                            class="register-input"></li>
                <li><span>验证码</span><input placeholder="请输入验证码" type="text" maxlength="20" name="captcha" v-model="form.code"
                                           class="register-code  register-input"/><i
                        class="code-img"><img id="guestbookCaptcha" :src="codeUrl" @click="getCode" ></i></li>
                <li class="register-btn">
                    <input type="hidden" name="token" value=""/>
                    <input type="button" @click="register" id="btn_sub" name="register" value="立即注册">
                </li>
            </ul>
        </div>
    </form>
  

</div>
<div class="login-copyright" style="color: #222">Copyright 广西壮族自治区粮油质量检验中心</div>
</div>
</div>
</template>

<script>
import { getCodeImg,registerUser } from "@/api/content/column";
export default {
    data() {
        return {
            form:{
                uuid:undefined,
                code:undefined,
                userName:undefined,
                userEmail:undefined,
                userPassword:undefined,
            },
            codeUrl:undefined,
        };
        
    },
    created(){
        this.getCode();
    },
    methods:{
    getCode() {
      getCodeImg().then(res => {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.form.uuid = res.uuid;
      });
    },
    register(){
        registerUser(this.form).then(res=>{
          const username = this.form.userName;
            this.$alert("<font color='red'>恭喜你，您的账号 " + username + " 注册成功！</font>", '系统提示', {
              dangerouslyUseHTMLString: true,
              type: 'success'
            }).then(() => {
              this.$router.push("/login");
            }).catch(() => {});
          }).catch(() => {
            this.loading = false;
            if (this.captchaEnabled) {
              this.getCode();
            }
          })
    },
    }

}
</script>


<style  scoped>
@import '../styles/home.css';
@import '../styles/pages.css';
@import '../styles/xcConfirm.css';
@import '../styles/style.css';
@import '../styles/login.css';
@import '../styles/font.css';
@import "../styles/index.css";
body{
  margin: 0;
  padding: 0;
  height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/register.vue